(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aurabreath-photo-guide"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('aurabreath-photo-guide'))customElements.define('aurabreath-photo-guide',class extends HTMLElement{
  connectedCallback(){
    this.cleanup?.();this.index=0;this.playing=false;this.inView=false;this.timer=null;
    this.controller=new AbortController();const opts={signal:this.controller.signal};
    this.steps=[...this.querySelectorAll('[data-step]')];this.frames=[...this.querySelectorAll('[data-frame]')];this.toggle=this.querySelector('[data-toggle]');this.motion=matchMedia('(prefers-reduced-motion: reduce)');
    this.steps.forEach((button,index)=>button.addEventListener('click',()=>{this.stop();this.show(index)},opts));
    this.toggle.hidden=false;this.toggle.addEventListener('click',()=>{if(this.playing)this.stop();else{if(this.index===this.steps.length-1)this.show(0);this.playing=true;this.sync();this.schedule()}},opts);
    this.addEventListener('focusin',event=>{if(event.target!==this.toggle)this.stop()},opts);
    document.addEventListener('visibilitychange',()=>{clearTimeout(this.timer);if(!document.hidden)this.schedule()},opts);
    this.motion.addEventListener('change',()=>{if(this.motion.matches)this.stop()},opts);
    const photo=this.querySelector('img');this.ready=!!photo&&photo.complete&&photo.naturalWidth>0;this.dataset.ready=String(this.ready);photo?.addEventListener('load',()=>{this.ready=true;this.dataset.ready='true';this.schedule()},opts);
    this.show(0);this.playing=this.dataset.autoplay==='true'&&this.dataset.editor!=='true'&&!this.motion.matches;this.sync();
    if('IntersectionObserver'in window){this.observer=new IntersectionObserver(entries=>{this.inView=entries[0].isIntersecting;this.dataset.visible=String(this.inView);clearTimeout(this.timer);if(this.inView)this.schedule()},{threshold:.35});this.observer.observe(this.querySelector('.ab-guide__visual'))}else{this.inView=true;this.dataset.visible='true';this.schedule()}
  }
  show(index){this.index=index;this.steps.forEach((button,i)=>{button.classList.toggle('is-active',i===index);button.setAttribute('aria-pressed',String(i===index));this.frames[i].classList.toggle('is-active',i===index);this.frames[i].setAttribute('aria-hidden',String(i!==index))});this.querySelector('[data-current]').textContent=String(index+1).padStart(2,'0')}
  sync(){this.dataset.playing=String(this.playing);this.querySelector('[data-toggle-label]').textContent=this.playing?this.dataset.pause:this.dataset.play}
  schedule(){clearTimeout(this.timer);if(!this.playing||!this.inView||!this.ready||document.hidden)return;this.timer=setTimeout(()=>{if(this.index===this.steps.length-1){this.stop();return}this.show(this.index+1);this.schedule()},5000)}
  stop(){this.playing=false;clearTimeout(this.timer);this.sync()}
  cleanup(){clearTimeout(this.timer);this.observer?.disconnect();this.controller?.abort()}
  disconnectedCallback(){this.cleanup()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aurabreath-premium-bundles"] && !Shopify.designMode) return;
  try {
    
  const mountAuraBreathBundles = () => {
    const bundle = document.querySelector('[data-aurabreath-bundles]');
    const productInfo = document.querySelector('product-info') || document.querySelector('.product__info-container');
    const productTitle = productInfo?.querySelector('.product__title');
    const productHeading = productTitle?.querySelector('h1, h2');
    if (productHeading) {
      productHeading.style.setProperty('font-size', '2.3rem', 'important');
      productHeading.style.setProperty('font-weight', '800', 'important');
      productHeading.style.setProperty('line-height', '1.12', 'important');
    }
    const productPrice = productInfo?.querySelector('[id^="price-"]');
    const productBenefits = productInfo?.querySelector('.aurabreath-product-carousel') || productInfo?.querySelector('.aurabreath-product-benefits');
    const bundleAnchor = productBenefits || productPrice || productTitle;

    if (bundle && bundleAnchor && bundleAnchor.nextElementSibling !== bundle) {
      bundleAnchor.insertAdjacentElement('afterend', bundle);
    }
  };

  mountAuraBreathBundles();
  document.addEventListener('shopify:section:load', mountAuraBreathBundles);

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-aurabreath-form]');
    if (!form) return;
    event.preventDefault();

    const button = form.querySelector('button[type="submit"]');
    const error = form.querySelector('[data-aurabreath-error]');
    const variantId = form.querySelector('[name="id"]').value;
    const quantity = Number(form.querySelector('[name="quantity"]:checked').value);
    const buttonLabel = button.querySelector('span');
    const originalLabel = buttonLabel.textContent;
    const cartUi = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    buttonLabel.textContent = form.dataset.adding;
    error.hidden = true;

    try {
      const requestBody = {
        items: [{ id: Number(variantId), quantity }]
      };

      if (cartUi && typeof cartUi.getSectionsToRender === 'function') {
        requestBody.sections = cartUi.getSectionsToRender().map((section) => section.id);
        requestBody.sections_url = window.location.pathname;
      }

      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(requestBody)
      });

      if (!response.ok) throw new Error('cart');
      const cartState = await response.json();
      buttonLabel.textContent = quantity > 1 ? form.dataset.addedMany.replace('[count]', quantity) : form.dataset.added;

      try {
        const sections = cartUi?.getSectionsToRender?.() || [];
        const canRender = cartUi && typeof cartUi.renderContents === 'function' && sections.length > 0 &&
          sections.every((section) => typeof cartState.sections?.[section.id] === 'string' && cartState.sections[section.id].trim());
        if (!canRender) {
          window.location.assign(window.Shopify.routes.root + 'cart');
          return;
        }
        cartUi.renderContents(cartState);
      } catch (renderError) {
        window.location.assign(window.Shopify.routes.root + 'cart');
        return;
      }

      fetch(window.Shopify.routes.root + 'cart.js')
        .then((cartResponse) => cartResponse.json())
        .then((cart) => {
          document.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { source: 'aurabreath-bundles', cart }
          }));
        })
        .catch(() => {});

      window.setTimeout(() => {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        buttonLabel.textContent = originalLabel;
      }, 1800);
    } catch (requestError) {
      error.textContent = form.dataset.error;
      error.hidden = false;
      button.disabled = false;
      button.removeAttribute('aria-busy');
      buttonLabel.textContent = originalLabel;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aurastep-sleep-stats"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aurastep-sleep-stats')) {
    customElements.define('aurastep-sleep-stats', class extends HTMLElement {
      connectedCallback() {
        this.frames = new Set();
        if (this.dataset.animate !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            const card = entry.target;
            this.observer.unobserve(card);
            card.classList.add('is-revealed');
            const number = card.querySelector('[data-count]');
            if (!number) return;
            const value = Number(card.dataset.stat);
            const decimals = Number(card.dataset.decimals);
            const formatter = new Intl.NumberFormat(document.documentElement.lang || 'fr', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
            const start = performance.now();
            const tick = time => {
              if (!this.isConnected) return;
              const progress = Math.min((time - start) / 1200, 1);
              number.textContent = formatter.format(value * (1 - Math.pow(1 - progress, 3)));
              if (progress < 1) {
                const frame = requestAnimationFrame(nextTime => { this.frames.delete(frame); tick(nextTime); });
                this.frames.add(frame);
              }
            };
            const frame = requestAnimationFrame(time => { this.frames.delete(frame); tick(time); });
            this.frames.add(frame);
          });
        }, { threshold: .25 });
        this.querySelectorAll('.as-sleep__card, .as-sleep__visual').forEach(card => this.observer.observe(card));
      }
      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.frames) this.frames.forEach(frame => cancelAnimationFrame(frame));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class AurastepMobileSearch extends HTMLElement {
    connectedCallback() {
      this.onReady = () => this.initialize();
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.onReady, { once: true });
      } else {
        this.initialize();
      }
    }

    initialize() {
      if (!this.isConnected || this.mediaQuery) return;
      this.header = this.closest('.header');
      this.search = this.header?.querySelector('details-modal.header__search');
      if (!this.search || this.contains(this.search)) return;

      this.originalParent = this.search.parentNode;
      this.originalNextSibling = this.search.nextSibling;
      this.sectionHeader = this.header.closest('.section-header');
      this.drawer = this.header.querySelector('header-drawer');
      this.drawerDetails = this.drawer?.querySelector('details');
      this.onDrawerToggle = () => this.updateDrawerPosition();
      this.drawerDetails?.addEventListener('toggle', this.onDrawerToggle);
      if (this.sectionHeader && typeof ResizeObserver !== 'undefined') {
        this.headerResizeObserver = new ResizeObserver(this.onDrawerToggle);
        this.headerResizeObserver.observe(this.sectionHeader);
      }
      this.onHeaderClick = (event) => {
        const target = event.target.closest('.header__icon--search, .header__icon--account, .header__icon--cart, .header__heading-link');
        if (target && this.drawerDetails?.open && typeof this.drawer.closeMenuDrawer === 'function') {
          this.drawer.closeMenuDrawer(event, target);
          this.drawerDetails.querySelector('summary')?.setAttribute('aria-expanded', 'false');
        }
        if (event.target.closest('.header__icon--menu') && this.search.querySelector('details[open]') && typeof this.search.close === 'function') {
          this.search.close(false);
        }
      };
      this.header.addEventListener('click', this.onHeaderClick, true);
      this.onDocumentKeyDown = (event) => {
        if (event.key !== 'Escape' && event.code?.toUpperCase() !== 'ESCAPE') return;
        const searchOpen = this.search.querySelector('details[open]');
        if (!searchOpen && !this.drawerDetails?.open) return;
        event.preventDefault();
        event.stopPropagation();
        if (searchOpen && typeof this.search.close === 'function') {
          this.search.close();
        } else if (this.drawerDetails?.open) {
          let openDetails = event.target.closest?.('details[open]');
          if (!openDetails || !this.drawer.contains(openDetails) || openDetails === this.drawerDetails) {
            const submenus = this.drawerDetails.querySelectorAll('details[open]');
            openDetails = submenus[submenus.length - 1] || this.drawerDetails;
          }
          if (openDetails !== this.drawerDetails && typeof this.drawer.closeSubmenu === 'function') {
            this.drawer.closeSubmenu(openDetails);
          } else if (typeof this.drawer.closeMenuDrawer === 'function') {
            const summary = this.drawerDetails.querySelector('summary');
            this.drawer.closeMenuDrawer(event, summary);
            summary?.setAttribute('aria-expanded', 'false');
          }
        }
      };
      document.addEventListener('keydown', this.onDocumentKeyDown, true);
      this.mediaQuery = window.matchMedia('(max-width: 989px)');
      this.onBreakpointChange = () => this.updateLayout();
      this.mediaQuery.addEventListener('change', this.onBreakpointChange);
      this.updateLayout();
    }

    updateDrawerPosition() {
      cancelAnimationFrame(this.drawerPositionFrame);
      if (!this.drawerDetails?.open || !this.sectionHeader) return;
      this.drawerPositionFrame = requestAnimationFrame(() => {
        if (!this.isConnected || !this.drawerDetails.open) return;
        const wrapper = this.header.closest('.header-wrapper');
        const border = wrapper ? parseFloat(getComputedStyle(wrapper).borderBottomWidth) || 0 : 0;
        const bottom = this.sectionHeader.getBoundingClientRect().bottom - border;
        this.sectionHeader.style.setProperty('--header-bottom-position', `${bottom}px`);
      });
    }

    updateLayout() {
      const mobile = this.mediaQuery.matches;
      const parent = mobile ? this : this.originalParent;
      if (this.search.parentNode !== parent) {
        const searchHadFocus = this.search.contains(document.activeElement);
        this.closeOverlays();
        if (mobile) {
          this.appendChild(this.search);
        } else {
          this.restoreSearch();
        }
        this.header.classList.toggle('aurastep-mobile-layout', mobile && this.search.parentNode === this);
        if (searchHadFocus) this.search.querySelector('summary')?.focus({ preventScroll: true });
      } else {
        this.header.classList.toggle('aurastep-mobile-layout', mobile && this.search.parentNode === this);
      }
    }

    closeOverlays(restoreFocus = true) {
      if (this.search?.querySelector('details[open]') && typeof this.search.close === 'function') {
        this.search.close(false);
      }

      const drawer = this.header?.querySelector('header-drawer');
      if (drawer?.querySelector('details[open]') && typeof drawer.closeMenuDrawer === 'function') {
        const activeElement = document.activeElement;
        const focusTarget = restoreFocus && drawer.contains(activeElement)
          ? this.header.querySelector('.header__heading-link')
          : activeElement;
        drawer.closeMenuDrawer(new Event('change'), focusTarget || document.body);
        drawer.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      }
    }

    restoreSearch() {
      const sibling = this.originalNextSibling?.parentNode === this.originalParent
        ? this.originalNextSibling
        : null;
      this.originalParent.insertBefore(this.search, sibling);
    }

    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded', this.onReady);
      if (!this.mediaQuery) return;
      this.mediaQuery.removeEventListener('change', this.onBreakpointChange);
      this.header.removeEventListener('click', this.onHeaderClick, true);
      document.removeEventListener('keydown', this.onDocumentKeyDown, true);
      this.drawerDetails?.removeEventListener('toggle', this.onDrawerToggle);
      this.headerResizeObserver?.disconnect();
      cancelAnimationFrame(this.drawerPositionFrame);
      this.sectionHeader?.style.removeProperty('--header-bottom-position');
      this.closeOverlays(false);
      if (this.search.parentNode === this) this.restoreSearch();
      this.header.classList.remove('aurastep-mobile-layout');
      this.mediaQuery = null;
    }
  }

  if (!customElements.get('aurastep-mobile-search')) {
    customElements.define('aurastep-mobile-search', AurastepMobileSearch);
  }

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (window.matchMedia('(min-width: 990px)').matches) {
        this.header.classList.toggle('aurastep-floating-active', scrollTop > 12);
        this.currentScrollTop = scrollTop;
        return;
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
